import type { SessionDataType } from '@confluence/session-data';

import {
	HOME_OVERVIEW_EXPERIENCE,
	HOME_RECENT_EXPERIENCE,
	HOME_STARRED_EXPERIENCE,
	HOME_WATCHING_EXPERIENCE,
	HOME_DRAFTS_EXPERIENCE,
	HOME_EXPERIENCE,
	HOME_SPACES_EXPERIENCE,
} from './ExperienceName';
import type { ExperienceEvent } from './ExperienceEvent';
import { isStop } from './ExperienceEvent';
import { getExperienceTracker } from './getExperienceTracker';
import type { Experience } from './Experience';

function collectHome(sessionData?: SessionDataType) {
	const homeExperiences = new Set<string>([
		HOME_OVERVIEW_EXPERIENCE,
		HOME_RECENT_EXPERIENCE,
		HOME_STARRED_EXPERIENCE,
		HOME_WATCHING_EXPERIENCE,
		HOME_DRAFTS_EXPERIENCE,
	]);

	//this and the sessionData argument can be removed when release tracks ships
	const isHomeRefreshEnabled = sessionData?.featureFlagClient.getBooleanValue(
		'confluence.frontend.home-visual-refresh',
		{ default: false },
	);
	return (events: ExperienceEvent[], experience: Experience) => {
		// stop as soon as any sub-experience is failed or aborted
		experience.stopOn(
			events.find(
				(event) =>
					(event.action === 'taskFail' || event.action === 'taskAbort') &&
					(homeExperiences.has(event.name) ||
						(event.name === HOME_SPACES_EXPERIENCE && isHomeRefreshEnabled)),
			),
		);

		// If any of the experiences succeed, the entire
		// experience should succeed
		let viewExperienceDidSucceed = false;
		let spacesExperienceDidSucceed = false;
		events.forEach((event) => {
			if (isStop(event)) {
				if (!isHomeRefreshEnabled) {
					if (homeExperiences.has(event.name)) {
						experience.succeed();
					}
				} else {
					if (homeExperiences.has(event.name)) {
						viewExperienceDidSucceed = true;
					}

					if (event.name === HOME_SPACES_EXPERIENCE && event.action === 'taskSuccess') {
						spacesExperienceDidSucceed = true;
					}
				}
			}
		});

		if (viewExperienceDidSucceed && spacesExperienceDidSucceed) {
			experience.succeed();
		}
	};
}

export function startHome(sessionData?: SessionDataType) {
	getExperienceTracker().start({
		name: HOME_EXPERIENCE,
		collect: collectHome(sessionData),
	});
}
